import { render, staticRenderFns } from "./Alteration.vue?vue&type=template&id=c928d09e&scoped=true"
import script from "./Alteration.vue?vue&type=script&lang=js"
export * from "./Alteration.vue?vue&type=script&lang=js"
import style0 from "./Alteration.vue?vue&type=style&index=0&id=c928d09e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c928d09e",
  null
  
)

export default component.exports